import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { Tag } from "lucide-react";

import { Input, Label, Button } from "components/ui";
import {
  AddReportCategoryAction,
  UpdateReportCategoryAction,
} from "store/middlewares/dataManagement/category";
import { SubmitLoaderButton } from "components/atoms";
import { closeAdminModal } from "store/slices/common/adminModal.slice";

function ModalEditReportCategory({ row, filter }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    const updateValue = { ...values, name: values.name.trim() };

    if (row) {
      dispatch(
        UpdateReportCategoryAction({
          id: row.id,
          isActive: row.is_active,
          ...updateValue,
          onSuccess: () => formik.setSubmitting(false),
          onError: () => setFormError(true),
        }),
      );
    } else {
      dispatch(
        AddReportCategoryAction({
          ...updateValue,
          filter,
          onSuccess: () => formik.setSubmitting(false),
          onError: () => setFormError(true),
        }),
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      name: row?.name ? row?.name : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Category name is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit} className="grid gap-5">
      {/* Title with icon */}
      <div className="flex items-center gap-3.5">
        <div className="flex size-11 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-700">
          <Tag className="size-5" aria-hidden="true" />
        </div>
        <h2 className="text-xl font-bold text-foreground">
          {row ? "Edit report category" : "Add report category"}
        </h2>
      </div>

      {/* Inputs (Stacked label + input) */}
      <div className="grid gap-4">
        <div className="flex flex-col gap-1.5">
          <Label>Name</Label>
          <Input
            error={formik.errors.name && formik.touched.name}
            errorMsg={formik.errors.name}
            value={formik.values.name}
            type="text"
            name="name"
            variant="lg"
            maxLength={50}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isTextOnly={true}
            isSpace={true}
            placeholder="Enter name"
            className="w-full"
          />
        </div>
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={() => dispatch(closeAdminModal())}
        >
          Cancel
        </Button>
        <SubmitLoaderButton
          btnText={row ? "Update" : "Add"}
          isDisable={formik.isSubmitting && !formError}
        />
      </div>
    </form>
  );
}

export default ModalEditReportCategory;